import { useSiteContent } from '@/context/SiteContentContext';

export default function AdminContactTab() {
  const { content, updateContent } = useSiteContent();
  const c = content.contact;
  const f = content.footer;

  return (
    <div className="space-y-5">
      <h3 className="text-lg font-bold text-gray-900 border-b border-gray-100 pb-3">Contact & Footer Details</h3>

      <div className="bg-gray-50 rounded-xl p-5 border border-gray-100 space-y-4">
        <p className="text-xs font-bold text-teal-600 uppercase tracking-widest">Contact Section</p>

        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-1.5">Office Address</label>
          <textarea
            value={c.address}
            rows={2}
            onChange={(e) => updateContent('contact.address', e.target.value)}
            className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-teal-500 resize-none bg-white"
          />
        </div>

        <div className="grid grid-cols-2 gap-3">
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-1.5">Phone 1</label>
            <input
              type="text"
              value={c.phone1}
              onChange={(e) => updateContent('contact.phone1', e.target.value)}
              className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-teal-500 bg-white"
            />
          </div>
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-1.5">WhatsApp Number</label>
            <input
              type="text"
              value={c.phone2}
              onChange={(e) => updateContent('contact.phone2', e.target.value)}
              className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-teal-500 bg-white"
            />
          </div>
        </div>

        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-1.5">Email</label>
          <input
            type="email"
            value={c.email}
            onChange={(e) => updateContent('contact.email', e.target.value)}
            className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-teal-500 bg-white"
          />
        </div>
      </div>

      <div className="bg-gray-50 rounded-xl p-5 border border-gray-100 space-y-4">
        <p className="text-xs font-bold text-teal-600 uppercase tracking-widest">Footer Section</p>

        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-1.5">Footer Tagline</label>
          <textarea
            value={f.tagline}
            rows={2}
            onChange={(e) => updateContent('footer.tagline', e.target.value)}
            className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-teal-500 resize-none bg-white"
          />
        </div>

        <div className="grid grid-cols-2 gap-3">
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-1.5">Footer Phone 1</label>
            <input
              type="text"
              value={f.phone1}
              onChange={(e) => updateContent('footer.phone1', e.target.value)}
              className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-teal-500 bg-white"
            />
          </div>
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-1.5">Footer WhatsApp</label>
            <input
              type="text"
              value={f.phone2}
              onChange={(e) => updateContent('footer.phone2', e.target.value)}
              className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-teal-500 bg-white"
            />
          </div>
        </div>

        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-1.5">Footer Email</label>
          <input
            type="email"
            value={f.email}
            onChange={(e) => updateContent('footer.email', e.target.value)}
            className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-teal-500 bg-white"
          />
        </div>

        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-1.5">Footer Address</label>
          <textarea
            value={f.address}
            rows={2}
            onChange={(e) => updateContent('footer.address', e.target.value)}
            className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-teal-500 resize-none bg-white"
          />
        </div>
      </div>
    </div>
  );
}
